
  document.addEventListener('DOMContentLoaded', function () {
    const stickyBtn = document.querySelector('.sticky-desktop-button');
    const trigger = document.querySelector('.product_page_btn');
    const header = document.querySelector('.shopify-section-header-sticky');

    if (!stickyBtn || !trigger) return;

    const isMobile = () => window.innerWidth <= 767;

    const setStickyPosition = () => {
      if (isMobile()) {
        stickyBtn.style.top = 'auto';
      } else {
        const headerHeight = header ? header.offsetHeight : 80;
        stickyBtn.style.top = headerHeight + 'px';
      }
    };

    setStickyPosition();
    window.addEventListener('resize', setStickyPosition);

    // Intersection Observer to toggle sticky visibility
    const observer = new IntersectionObserver(
      ([entry]) => {
        const outOfView = entry.boundingClientRect.bottom < 0 || !entry.isIntersecting;
        if (outOfView) {
          stickyBtn.classList.remove('hidden');
        } else {
          stickyBtn.classList.add('hidden');
        }
      },
      { root: null, threshold: 0 }
    );

    window.addEventListener('load', () => {
      setTimeout(() => {
        observer.observe(trigger);
      }, 300);
    });

    // Optional scroll direction logic
    let lastScrollTop = window.pageYOffset;
    window.addEventListener('scroll', () => {
      const currentScroll = window.pageYOffset;
      if (currentScroll > lastScrollTop) {
        stickyBtn.classList.remove('hide-on-scroll-up');
      } else {
        stickyBtn.classList.add('hide-on-scroll-up');
      }
      lastScrollTop = currentScroll <= 0 ? 0 : currentScroll;
    });
  });
